import { Injectable, inject } from '@angular/core';
import { SurveyMeasurementStatuses } from '@core/enums/survey-measurement-statuses';
import { AlarmConfig } from '@core/interfaces/alarm-config';
import { SaveMeasurementResult } from '@core/interfaces/save-measurement-result';
import { SurveyMeasurement } from '@core/interfaces/survey-measurement';
import { SurveyPoint } from '@core/interfaces/survey-point';
import { MeasurementHelper } from '@core/helpers/measurement.helper';
import { CorrosionMonitoringLocationsService } from 'src/app/mobile/services/corrosion-monitoring-locations.service';
import { LoggerService } from '@shared/services/logger.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThicknessService {
  readonly #cmlService = inject(CorrosionMonitoringLocationsService);
  #logger = inject(LoggerService);

  public saveThickness(
    row: SurveyMeasurement,
    thickness: number,
    oldThicknessMeasurement: number,
    selectedPoint: SurveyPoint,
    alarmConfig: AlarmConfig,
    metadataId: string,
    taskId: string,
  ): Promise<SaveMeasurementResult> {
    row.serialNumber = localStorage.getItem('serialnumber');
    return new Promise<SaveMeasurementResult>(resolve => {
      if (thickness !== 0) {
        this.saveMeasurement(selectedPoint, oldThicknessMeasurement, row, alarmConfig, metadataId, taskId).then(result => {
          resolve(result);
        });
      } else {
        resolve({ rowSelectionAction: 'stayOnCurrent', errorOccured: true, measurementToSet: oldThicknessMeasurement });
      }
    });
  }

  private saveMeasurement(
    savedPoint: SurveyPoint,
    oldMeasurement: number,
    row: SurveyMeasurement,
    alarmConfig: AlarmConfig,
    metadataId: string,
    taskId: string,
  ): Promise<SaveMeasurementResult> {
    return new Promise<SaveMeasurementResult>(resolve => {
      if (MeasurementHelper.isMeasurementInAlarmState(row.measurement, row.previousMeasurement, alarmConfig)) {
        row.status = SurveyMeasurementStatuses.CompleteWithAlarm;
        if (alarmConfig.confirmBeforeSave) {
          firstValueFrom(this.#cmlService.updateCML(metadataId, savedPoint, taskId, alarmConfig))
            .then(() => {
              resolve({ rowSelectionAction: 'selectNext', errorOccured: false, measurementToSet: row.measurement });
            })
            .catch(err => {
              this.#logger.error('ThicknessService.saveMeasurement-if-confirmBeforeSave', err);
              resolve({ rowSelectionAction: 'stayOnCurrent', errorOccured: true, measurementToSet: oldMeasurement });
            });
        } else {
          firstValueFrom(this.#cmlService.updateCML(metadataId, savedPoint, taskId, alarmConfig))
            .then(() => {
              resolve({ rowSelectionAction: 'selectNext', errorOccured: false, measurementToSet: row.measurement });
            })
            .catch(err => {
              this.#logger.error('ThicknessService.saveMeasurement-else-ConfirmBeforeSave', err);
              resolve({ rowSelectionAction: 'stayOnCurrent', errorOccured: true, measurementToSet: oldMeasurement });
            });
        }
      } else {
        row.status = SurveyMeasurementStatuses.Complete;
        firstValueFrom(this.#cmlService.updateCML(metadataId, savedPoint, taskId, alarmConfig))
          .then(() => {
            resolve({ rowSelectionAction: 'selectNext', errorOccured: false, measurementToSet: row.measurement });
          })
          .catch(err => {
            this.#logger.error('ThicknessService.saveMeasurement-else-isMeasurementInAlarmState', err);
            resolve({ rowSelectionAction: 'stayOnCurrent', errorOccured: true, measurementToSet: oldMeasurement });
          });
      }
    });
  }
}
